"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOAD_DISPLAY_NAME = exports.AS400_STATUS_DISPLAY = exports.AS400_STATUS_DISPLAY_NAME = exports.TRACKER_VISIBLE_AS400_STATUSES = exports.ADDITIONAL_BILLING_VISIBLE_STATUS = exports.TRACKER_VISIBLE_STATUSES = exports.BILLING_LOAD_STATUS = exports.TRACKING_LOAD_STATUSES = exports.ACTIVE_LOAD_STATUSES = exports.DROPOFF_LOAD_STATUSES = exports.PICKUP_LOAD_STATUSES = exports.ON_ADDITIONAL_BILLING_STATUS_FROM_API = exports.ON_ADDITIONAL_BILLING_STATUS_SHORT_TEXT = exports.ON_ADDITIONAL_BILLING_STATUS_LIST = exports.ON_ADDITIONAL_BILLING_STATUS_API = exports.ON_ADDITIONAL_BILLING_STATUS = exports.ON_BILLING_STATUS_FROM_API = exports.ON_BILLING_STATUS_SHORT_TEXT = exports.ON_BILLING_STATUS_LIST = exports.ON_BILLING_STATUS_API = exports.ON_BILLING_STATUS = exports.ON_ASSIGNMENT_STATUS_LIST = exports.ON_ASSIGNMENT_STATUS_SHORT_TEXT = exports.ON_ASSIGNMENT_STATUS_TEXT = exports.ON_ASSIGNMENT_STATUS_FROM_API = exports.ON_ASSIGNMENT_STATUS_API = exports.ON_ASSIGNMENT_STATUS = exports.ON_TIME_STATUS_DROPOFF = exports.ON_TIME_STATUS_PICKUP = exports.BILL_TO_TEXT = exports.MODE_OPTION_TEXT = exports.ON_TIME_STATUS_SHORT_TEXT = exports.ON_TIME_STATUS_TEXT = exports.ON_TIME_STATUS_FROM_API = exports.ON_TIME_STATUS_API = exports.ON_TIME_STATUS = exports.LOWER_ACCURACY_LIMIT = exports.UPPER_ACCURACY_LIMIT = exports.LOWER_SPEED_LIMIT = exports.UPPER_SPEED_LIMIT = exports.LOAD_DEPARTED_THRESHOLD = exports.LOAD_ARRIVED_THRESHOLD = exports.LOAD_NEARBY_THRESHOLD = exports.LOAD_BILL_TO_CHOICES = exports.LOAD_MODE_CHOICES = exports.LOAD_TRANSITION = exports.ADDITIONAL_BILLING_STATUS = exports.LOAD_STATUS = exports.LOAD_STOP_TYPE = exports.AS400_STATUS = void 0;
exports.VISIBLE_ID_FETCH_LIMIT = exports.TABLE_ROW_FETCH_LIMIT = exports.ALLOWED_OPERATIONAL_BILLING_STATUSES = exports.BILLING_STATUSES = exports.TIMESTAMPD_STATUSES = exports.INACTIVE_STATUSES = exports.LOAD_ORDER = exports.getTransitions = exports.getNextStatus = exports.NEXT_SWIPE_LOAD_STATUS = exports.getChipDisplayClass = exports.getAS400DisplayStatus = exports.getAPIStatus = exports.getAdditionalBillingDisplayStatus = exports.getDisplayStatus = exports.getBillingIssueDisplayLabel = void 0;
var convert_units_1 = __importDefault(require("convert-units"));
var moment_1 = __importDefault(require("moment"));
// SEE: api/docmate/loads/constants.py
var AS400_STATUS;
(function (AS400_STATUS) {
    AS400_STATUS["NA"] = "NA";
    AS400_STATUS["PENDING"] = "P";
    AS400_STATUS["ACCEPTED_A"] = "A";
    AS400_STATUS["ACCEPTED_I"] = "I";
    AS400_STATUS["DECLINED_R"] = "R";
    AS400_STATUS["DECLINED_D"] = "D";
    AS400_STATUS["COMPLETE"] = "F";
    AS400_STATUS["CANCELLED"] = "X";
})(AS400_STATUS = exports.AS400_STATUS || (exports.AS400_STATUS = {}));
// SEE: api/docmate/loads/constants.py
var LOAD_STOP_TYPE;
(function (LOAD_STOP_TYPE) {
    LOAD_STOP_TYPE["PICKUP"] = "P";
    LOAD_STOP_TYPE["DROPOFF"] = "D";
})(LOAD_STOP_TYPE = exports.LOAD_STOP_TYPE || (exports.LOAD_STOP_TYPE = {}));
// SEE: api/docmate/loads/constants.py
var LOAD_STATUS;
(function (LOAD_STATUS) {
    LOAD_STATUS["UNASSIGNED"] = "unassigned";
    LOAD_STATUS["DECLINED"] = "declined";
    LOAD_STATUS["PENDING_ACCEPTANCE"] = "pending_acceptance";
    LOAD_STATUS["ASSIGNED"] = "assigned";
    LOAD_STATUS["ACTIVE"] = "active";
    LOAD_STATUS["PICKUP_ACCEPTED"] = "pickup_accepted";
    LOAD_STATUS["PICKUP_GOING"] = "pickup_going";
    LOAD_STATUS["PICKUP_ARRIVED"] = "pickup_arrived";
    LOAD_STATUS["PICKUP_CHECKIN"] = "pickup_checkin";
    LOAD_STATUS["PICKUP_DEPARTED"] = "pickup_departed";
    LOAD_STATUS["DROPOFF_ACCEPTED"] = "dropoff_accepted";
    LOAD_STATUS["DROPOFF_GOING"] = "dropoff_going";
    LOAD_STATUS["DROPOFF_ARRIVED"] = "dropoff_arrived";
    LOAD_STATUS["DROPOFF_CHECKIN"] = "dropoff_checkin";
    LOAD_STATUS["DELIVERED"] = "delivered";
    LOAD_STATUS["COMPLETED"] = "completed";
    LOAD_STATUS["CANCELLED"] = "cancelled";
    LOAD_STATUS["DISPATCH_VERIFIED"] = "dispatch_verified";
    LOAD_STATUS["BILLING_ISSUE"] = "billing_issue";
    LOAD_STATUS["INVOICED"] = "invoiced";
})(LOAD_STATUS = exports.LOAD_STATUS || (exports.LOAD_STATUS = {}));
var ADDITIONAL_BILLING_STATUS;
(function (ADDITIONAL_BILLING_STATUS) {
    ADDITIONAL_BILLING_STATUS["PENDING"] = "pending";
    ADDITIONAL_BILLING_STATUS["APPROVED"] = "approved";
    ADDITIONAL_BILLING_STATUS["DENIED"] = "denied";
    ADDITIONAL_BILLING_STATUS["BILLING_ISSUE"] = "billing_issue";
    ADDITIONAL_BILLING_STATUS["INVOICED"] = "invoiced";
})(ADDITIONAL_BILLING_STATUS = exports.ADDITIONAL_BILLING_STATUS || (exports.ADDITIONAL_BILLING_STATUS = {}));
// SEE: api/docmate/loads/models.py
var LOAD_TRANSITION;
(function (LOAD_TRANSITION) {
    LOAD_TRANSITION["RESET_STATUS"] = "reset_status";
    LOAD_TRANSITION["ASSIGN_DRIVER"] = "assign_driver";
    LOAD_TRANSITION["ACCEPT"] = "pickup_accept";
    LOAD_TRANSITION["DECLINE"] = "pickup_decline";
    LOAD_TRANSITION["ACTIVE"] = "active";
    LOAD_TRANSITION["PICKUP_GO"] = "pickup_go";
    LOAD_TRANSITION["PICKUP_NEARBY"] = "pickup_nearby";
    LOAD_TRANSITION["PICKUP_TROUBLE"] = "pickup_trouble";
    LOAD_TRANSITION["PICKUP_ARRIVE"] = "pickup_arrive";
    LOAD_TRANSITION["PICKUP_CHECKIN"] = "pickup_checkin";
    LOAD_TRANSITION["PICKUP_DEPART"] = "pickup_depart";
    LOAD_TRANSITION["DROPOFF_ACCEPT"] = "dropoff_accept";
    LOAD_TRANSITION["DROPOFF_GO"] = "dropoff_go";
    LOAD_TRANSITION["DROPOFF_NEARBY"] = "dropoff_nearby";
    LOAD_TRANSITION["DROPOFF_TROUBLE"] = "dropoff_trouble";
    LOAD_TRANSITION["DROPOFF_ARRIVE"] = "dropoff_arrive";
    LOAD_TRANSITION["DROPOFF_CHECKIN"] = "dropoff_checkin";
    LOAD_TRANSITION["DROPOFF_COMPLETE"] = "dropoff_complete";
    LOAD_TRANSITION["BULK_PICKUP_ARRIVE"] = "bulk_pickup_arrive";
    LOAD_TRANSITION["BULK_PICKUP_DEPART"] = "bulk_pickup_depart";
    LOAD_TRANSITION["BULK_DROPOFF_FULL"] = "bulk_dropoff_full";
    LOAD_TRANSITION["BULK_DROPOFF_ARRIVE"] = "bulk_dropoff_arrive";
})(LOAD_TRANSITION = exports.LOAD_TRANSITION || (exports.LOAD_TRANSITION = {}));
var LOAD_MODE_CHOICES;
(function (LOAD_MODE_CHOICES) {
    LOAD_MODE_CHOICES["DROP_AND_HOOK"] = "drop_and_hook";
    LOAD_MODE_CHOICES["POWER_ONLY"] = "power_only";
    LOAD_MODE_CHOICES["LIVE_LOAD"] = "live_load";
})(LOAD_MODE_CHOICES = exports.LOAD_MODE_CHOICES || (exports.LOAD_MODE_CHOICES = {}));
var LOAD_BILL_TO_CHOICES;
(function (LOAD_BILL_TO_CHOICES) {
    LOAD_BILL_TO_CHOICES["SHIPPER"] = "shipper";
    LOAD_BILL_TO_CHOICES["CONSIGNEE"] = "consignee";
    LOAD_BILL_TO_CHOICES["THIRD_PARTY"] = "third_party";
})(LOAD_BILL_TO_CHOICES = exports.LOAD_BILL_TO_CHOICES || (exports.LOAD_BILL_TO_CHOICES = {}));
exports.LOAD_NEARBY_THRESHOLD = moment_1.default.duration('00:20:00'); // 20 minutes
exports.LOAD_ARRIVED_THRESHOLD = moment_1.default.duration('00:02:00'); // 2 minutes
exports.LOAD_DEPARTED_THRESHOLD = 1.0; // 1 mile radius
exports.UPPER_SPEED_LIMIT = (0, convert_units_1.default)(10)
    .from('m/h')
    .to('m/s');
exports.LOWER_SPEED_LIMIT = (0, convert_units_1.default)(7.5)
    .from('m/h')
    .to('m/s');
exports.UPPER_ACCURACY_LIMIT = 20; // 20 meters
exports.LOWER_ACCURACY_LIMIT = 15; // 15 meters
var ON_TIME_STATUS;
(function (ON_TIME_STATUS) {
    ON_TIME_STATUS[ON_TIME_STATUS["UNKNOWN"] = 0] = "UNKNOWN";
    ON_TIME_STATUS[ON_TIME_STATUS["PROCESSING"] = 1] = "PROCESSING";
    ON_TIME_STATUS[ON_TIME_STATUS["LOAD_STARTED"] = 2] = "LOAD_STARTED";
    ON_TIME_STATUS[ON_TIME_STATUS["PICKUP_EARLY"] = 3] = "PICKUP_EARLY";
    ON_TIME_STATUS[ON_TIME_STATUS["PICKUP_ON_TIME"] = 4] = "PICKUP_ON_TIME";
    ON_TIME_STATUS[ON_TIME_STATUS["PICKUP_AT_RISK"] = 5] = "PICKUP_AT_RISK";
    ON_TIME_STATUS[ON_TIME_STATUS["PICKUP_ARRIVED"] = 6] = "PICKUP_ARRIVED";
    ON_TIME_STATUS[ON_TIME_STATUS["PICKUP_MISSED"] = 7] = "PICKUP_MISSED";
    ON_TIME_STATUS[ON_TIME_STATUS["PICKUP_CHECKEDIN"] = 8] = "PICKUP_CHECKEDIN";
    ON_TIME_STATUS[ON_TIME_STATUS["PICKUP_DETENTION"] = 9] = "PICKUP_DETENTION";
    ON_TIME_STATUS[ON_TIME_STATUS["DROPOFF_EARLY"] = 10] = "DROPOFF_EARLY";
    ON_TIME_STATUS[ON_TIME_STATUS["DROPOFF_ON_TIME"] = 11] = "DROPOFF_ON_TIME";
    ON_TIME_STATUS[ON_TIME_STATUS["DROPOFF_AT_RISK"] = 12] = "DROPOFF_AT_RISK";
    ON_TIME_STATUS[ON_TIME_STATUS["DROPOFF_ARRIVED"] = 13] = "DROPOFF_ARRIVED";
    ON_TIME_STATUS[ON_TIME_STATUS["DROPOFF_MISSED"] = 14] = "DROPOFF_MISSED";
    ON_TIME_STATUS[ON_TIME_STATUS["DROPOFF_CHECKEDIN"] = 15] = "DROPOFF_CHECKEDIN";
    ON_TIME_STATUS[ON_TIME_STATUS["DROPOFF_DETENTION"] = 16] = "DROPOFF_DETENTION";
    ON_TIME_STATUS[ON_TIME_STATUS["PICKED_UP"] = 17] = "PICKED_UP";
    ON_TIME_STATUS[ON_TIME_STATUS["DELIVERED"] = 18] = "DELIVERED";
    ON_TIME_STATUS[ON_TIME_STATUS["COMPLETED"] = 19] = "COMPLETED";
})(ON_TIME_STATUS = exports.ON_TIME_STATUS || (exports.ON_TIME_STATUS = {}));
exports.ON_TIME_STATUS_API = (_a = {},
    _a[ON_TIME_STATUS.UNKNOWN] = 'unknown',
    _a[ON_TIME_STATUS.PROCESSING] = 'processing',
    _a[ON_TIME_STATUS.LOAD_STARTED] = 'load_started',
    _a[ON_TIME_STATUS.PICKUP_EARLY] = 'pickup_early',
    _a[ON_TIME_STATUS.PICKUP_ON_TIME] = 'pickup_on_time',
    _a[ON_TIME_STATUS.PICKUP_AT_RISK] = 'pickup_at_risk',
    _a[ON_TIME_STATUS.PICKUP_ARRIVED] = 'pickup_arrived',
    _a[ON_TIME_STATUS.PICKUP_MISSED] = 'pickup_missed',
    _a[ON_TIME_STATUS.PICKUP_CHECKEDIN] = 'pickup_checkedin',
    _a[ON_TIME_STATUS.PICKUP_DETENTION] = 'pickup_detention',
    _a[ON_TIME_STATUS.DROPOFF_EARLY] = 'dropoff_early',
    _a[ON_TIME_STATUS.DROPOFF_ON_TIME] = 'dropoff_on_time',
    _a[ON_TIME_STATUS.DROPOFF_AT_RISK] = 'dropoff_at_risk',
    _a[ON_TIME_STATUS.DROPOFF_ARRIVED] = 'dropoff_arrived',
    _a[ON_TIME_STATUS.DROPOFF_MISSED] = 'dropoff_missed',
    _a[ON_TIME_STATUS.DROPOFF_CHECKEDIN] = 'dropoff_checkedin',
    _a[ON_TIME_STATUS.DROPOFF_DETENTION] = 'dropoff_detention',
    _a[ON_TIME_STATUS.PICKED_UP] = 'picked_up',
    _a[ON_TIME_STATUS.DELIVERED] = 'delivered',
    _a[ON_TIME_STATUS.COMPLETED] = 'completed',
    _a);
exports.ON_TIME_STATUS_FROM_API = {
    unknown: ON_TIME_STATUS.UNKNOWN,
    processing: ON_TIME_STATUS.PROCESSING,
    load_started: ON_TIME_STATUS.LOAD_STARTED,
    pickup_early: ON_TIME_STATUS.PICKUP_EARLY,
    pickup_on_time: ON_TIME_STATUS.PICKUP_ON_TIME,
    pickup_at_risk: ON_TIME_STATUS.PICKUP_AT_RISK,
    pickup_arrived: ON_TIME_STATUS.PICKUP_ARRIVED,
    pickup_missed: ON_TIME_STATUS.PICKUP_MISSED,
    pickup_checkedin: ON_TIME_STATUS.PICKUP_CHECKEDIN,
    pickup_detention: ON_TIME_STATUS.PICKUP_DETENTION,
    dropoff_early: ON_TIME_STATUS.DROPOFF_EARLY,
    dropoff_on_time: ON_TIME_STATUS.DROPOFF_ON_TIME,
    dropoff_at_risk: ON_TIME_STATUS.DROPOFF_AT_RISK,
    dropoff_arrived: ON_TIME_STATUS.DROPOFF_ARRIVED,
    dropoff_missed: ON_TIME_STATUS.DROPOFF_MISSED,
    dropoff_checkedin: ON_TIME_STATUS.DROPOFF_CHECKEDIN,
    dropoff_detention: ON_TIME_STATUS.DROPOFF_DETENTION,
    picked_up: ON_TIME_STATUS.PICKED_UP,
    delivered: ON_TIME_STATUS.DELIVERED,
    completed: ON_TIME_STATUS.COMPLETED,
};
exports.ON_TIME_STATUS_TEXT = (_b = {},
    _b[ON_TIME_STATUS.UNKNOWN] = 'Unknown',
    _b[ON_TIME_STATUS.PROCESSING] = 'Processing',
    _b[ON_TIME_STATUS.LOAD_STARTED] = 'Load Assigned',
    _b[ON_TIME_STATUS.PICKUP_EARLY] = 'En Route to Pick-up - Early',
    _b[ON_TIME_STATUS.PICKUP_ON_TIME] = 'En Route to Pick-up - On Time',
    _b[ON_TIME_STATUS.PICKUP_AT_RISK] = 'En Route to Pick-up - At Risk',
    _b[ON_TIME_STATUS.PICKUP_ARRIVED] = 'Arrived at Pick-up',
    _b[ON_TIME_STATUS.PICKUP_MISSED] = 'En Route to Pick-up - Missed',
    _b[ON_TIME_STATUS.PICKUP_CHECKEDIN] = 'Checked-in at Pick-up',
    _b[ON_TIME_STATUS.PICKUP_DETENTION] = 'In Detention at Pick-up',
    _b[ON_TIME_STATUS.DROPOFF_EARLY] = 'En Route to Drop-off - Early',
    _b[ON_TIME_STATUS.DROPOFF_ON_TIME] = 'En Route to Drop-off - On Time',
    _b[ON_TIME_STATUS.DROPOFF_AT_RISK] = 'En Route to Drop-off - At Risk',
    _b[ON_TIME_STATUS.DROPOFF_ARRIVED] = 'Arrived at Drop-off',
    _b[ON_TIME_STATUS.DROPOFF_MISSED] = 'En Route to Drop-off - Missed',
    _b[ON_TIME_STATUS.DROPOFF_CHECKEDIN] = 'Checked-in at Drop-off',
    _b[ON_TIME_STATUS.DROPOFF_DETENTION] = 'In Detention at Drop-off',
    _b[ON_TIME_STATUS.PICKED_UP] = 'Picked Up',
    _b[ON_TIME_STATUS.DELIVERED] = 'Delivered',
    _b[ON_TIME_STATUS.COMPLETED] = 'Completed',
    _b);
exports.ON_TIME_STATUS_SHORT_TEXT = (_c = {},
    _c[ON_TIME_STATUS.UNKNOWN] = 'Unknown',
    _c[ON_TIME_STATUS.PROCESSING] = 'Processing',
    _c[ON_TIME_STATUS.LOAD_STARTED] = 'Started',
    _c[ON_TIME_STATUS.PICKUP_EARLY] = 'Early',
    _c[ON_TIME_STATUS.PICKUP_ON_TIME] = 'On Time',
    _c[ON_TIME_STATUS.PICKUP_AT_RISK] = 'At Risk',
    _c[ON_TIME_STATUS.PICKUP_ARRIVED] = 'Arrived',
    _c[ON_TIME_STATUS.PICKUP_MISSED] = 'Delayed',
    _c[ON_TIME_STATUS.PICKUP_CHECKEDIN] = 'Checked-in',
    _c[ON_TIME_STATUS.PICKUP_DETENTION] = 'Detention',
    _c[ON_TIME_STATUS.DROPOFF_EARLY] = 'Early',
    _c[ON_TIME_STATUS.DROPOFF_ON_TIME] = 'On Time',
    _c[ON_TIME_STATUS.DROPOFF_AT_RISK] = 'At Risk',
    _c[ON_TIME_STATUS.DROPOFF_ARRIVED] = 'Arrived',
    _c[ON_TIME_STATUS.DROPOFF_MISSED] = 'Delayed',
    _c[ON_TIME_STATUS.DROPOFF_CHECKEDIN] = 'Checked-in',
    _c[ON_TIME_STATUS.DROPOFF_DETENTION] = 'Detention',
    _c[ON_TIME_STATUS.PICKED_UP] = 'Picked Up',
    _c[ON_TIME_STATUS.DELIVERED] = 'Delivered',
    _c[ON_TIME_STATUS.COMPLETED] = 'Completed',
    _c);
exports.MODE_OPTION_TEXT = (_d = {},
    _d[LOAD_MODE_CHOICES.DROP_AND_HOOK] = 'Drop and Hook',
    _d[LOAD_MODE_CHOICES.LIVE_LOAD] = 'Live Load',
    _d[LOAD_MODE_CHOICES.POWER_ONLY] = 'Power Only',
    _d);
exports.BILL_TO_TEXT = (_e = {},
    _e[LOAD_BILL_TO_CHOICES.SHIPPER] = 'Prepaid Shipper',
    _e[LOAD_BILL_TO_CHOICES.CONSIGNEE] = 'Consignee',
    _e[LOAD_BILL_TO_CHOICES.THIRD_PARTY] = 'Third Party',
    _e);
exports.ON_TIME_STATUS_PICKUP = [
    ON_TIME_STATUS.PICKUP_EARLY,
    ON_TIME_STATUS.PICKUP_ON_TIME,
    ON_TIME_STATUS.PICKUP_AT_RISK,
    ON_TIME_STATUS.PICKUP_MISSED,
    ON_TIME_STATUS.PICKUP_ARRIVED,
    ON_TIME_STATUS.PICKUP_DETENTION,
];
exports.ON_TIME_STATUS_DROPOFF = [
    ON_TIME_STATUS.DROPOFF_EARLY,
    ON_TIME_STATUS.DROPOFF_ON_TIME,
    ON_TIME_STATUS.DROPOFF_AT_RISK,
    ON_TIME_STATUS.DROPOFF_MISSED,
    ON_TIME_STATUS.DROPOFF_ARRIVED,
    ON_TIME_STATUS.DROPOFF_DETENTION,
];
var ON_ASSIGNMENT_STATUS;
(function (ON_ASSIGNMENT_STATUS) {
    ON_ASSIGNMENT_STATUS[ON_ASSIGNMENT_STATUS["UNKNOWN"] = 0] = "UNKNOWN";
    ON_ASSIGNMENT_STATUS[ON_ASSIGNMENT_STATUS["ASSIGNMENT_UNASSIGNED"] = 1] = "ASSIGNMENT_UNASSIGNED";
    // ASSIGNMENT_AT_RISK,
    ON_ASSIGNMENT_STATUS[ON_ASSIGNMENT_STATUS["ASSIGNMENT_ASSIGNED"] = 2] = "ASSIGNMENT_ASSIGNED";
})(ON_ASSIGNMENT_STATUS = exports.ON_ASSIGNMENT_STATUS || (exports.ON_ASSIGNMENT_STATUS = {}));
exports.ON_ASSIGNMENT_STATUS_API = (_f = {},
    _f[ON_ASSIGNMENT_STATUS.UNKNOWN] = 'unknown',
    _f[ON_ASSIGNMENT_STATUS.ASSIGNMENT_UNASSIGNED] = 'assignment_unassigned',
    // [ON_ASSIGNMENT_STATUS.ASSIGNMENT_AT_RISK]: 'assignment_at_risk',
    _f[ON_ASSIGNMENT_STATUS.ASSIGNMENT_ASSIGNED] = 'assignment_assigned',
    _f);
exports.ON_ASSIGNMENT_STATUS_FROM_API = {
    unknown: ON_ASSIGNMENT_STATUS.UNKNOWN,
    assignment_unassigned: ON_ASSIGNMENT_STATUS.ASSIGNMENT_UNASSIGNED,
    // assignment_at_risk: ON_ASSIGNMENT_STATUS.ASSIGNMENT_AT_RISK,
    assignment_assigned: ON_ASSIGNMENT_STATUS.ASSIGNMENT_ASSIGNED,
};
exports.ON_ASSIGNMENT_STATUS_TEXT = (_g = {},
    _g[ON_ASSIGNMENT_STATUS.UNKNOWN] = 'Unknown',
    _g[ON_ASSIGNMENT_STATUS.ASSIGNMENT_UNASSIGNED] = 'Unassigned',
    // [ON_ASSIGNMENT_STATUS.ASSIGNMENT_AT_RISK]: 'Pre-Assignment Risk',
    _g[ON_ASSIGNMENT_STATUS.ASSIGNMENT_ASSIGNED] = 'Assigned',
    _g);
exports.ON_ASSIGNMENT_STATUS_SHORT_TEXT = (_h = {},
    _h[ON_ASSIGNMENT_STATUS.UNKNOWN] = 'Unknown',
    _h[ON_ASSIGNMENT_STATUS.ASSIGNMENT_UNASSIGNED] = 'Unassigned',
    // [ON_ASSIGNMENT_STATUS.ASSIGNMENT_AT_RISK]: 'At Risk',
    _h[ON_ASSIGNMENT_STATUS.ASSIGNMENT_ASSIGNED] = 'Assigned',
    _h);
exports.ON_ASSIGNMENT_STATUS_LIST = [
    ON_ASSIGNMENT_STATUS.ASSIGNMENT_UNASSIGNED,
    // ON_ASSIGNMENT_STATUS.ASSIGNMENT_AT_RISK,
    ON_ASSIGNMENT_STATUS.ASSIGNMENT_ASSIGNED,
];
var ON_BILLING_STATUS;
(function (ON_BILLING_STATUS) {
    ON_BILLING_STATUS[ON_BILLING_STATUS["UNKNOWN"] = 0] = "UNKNOWN";
    ON_BILLING_STATUS[ON_BILLING_STATUS["DISPATCH_VERIFIED"] = 1] = "DISPATCH_VERIFIED";
    ON_BILLING_STATUS[ON_BILLING_STATUS["BILLING_ISSUE"] = 2] = "BILLING_ISSUE";
    ON_BILLING_STATUS[ON_BILLING_STATUS["INVOICED"] = 3] = "INVOICED";
})(ON_BILLING_STATUS = exports.ON_BILLING_STATUS || (exports.ON_BILLING_STATUS = {}));
exports.ON_BILLING_STATUS_API = (_j = {},
    _j[ON_BILLING_STATUS.UNKNOWN] = 'unknown',
    _j[ON_BILLING_STATUS.DISPATCH_VERIFIED] = 'dispatch_verified',
    _j[ON_BILLING_STATUS.BILLING_ISSUE] = 'billing_issue',
    _j[ON_BILLING_STATUS.INVOICED] = 'invoiced',
    _j);
exports.ON_BILLING_STATUS_LIST = [
    ON_BILLING_STATUS.DISPATCH_VERIFIED,
    ON_BILLING_STATUS.BILLING_ISSUE,
    ON_BILLING_STATUS.INVOICED,
];
exports.ON_BILLING_STATUS_SHORT_TEXT = (_k = {},
    _k[ON_BILLING_STATUS.UNKNOWN] = 'unknown',
    _k[ON_BILLING_STATUS.DISPATCH_VERIFIED] = 'Dispatch Verified',
    _k[ON_BILLING_STATUS.BILLING_ISSUE] = 'Billing Issue',
    _k[ON_BILLING_STATUS.INVOICED] = 'Invoiced',
    _k);
exports.ON_BILLING_STATUS_FROM_API = {
    dispatch_verified: ON_BILLING_STATUS.DISPATCH_VERIFIED,
    billing_issue: ON_BILLING_STATUS.BILLING_ISSUE,
    invoiced: ON_BILLING_STATUS.INVOICED,
};
var ON_ADDITIONAL_BILLING_STATUS;
(function (ON_ADDITIONAL_BILLING_STATUS) {
    ON_ADDITIONAL_BILLING_STATUS[ON_ADDITIONAL_BILLING_STATUS["PENDING"] = 0] = "PENDING";
    ON_ADDITIONAL_BILLING_STATUS[ON_ADDITIONAL_BILLING_STATUS["APPROVED"] = 1] = "APPROVED";
    ON_ADDITIONAL_BILLING_STATUS[ON_ADDITIONAL_BILLING_STATUS["BILLING_ISSUE"] = 2] = "BILLING_ISSUE";
    ON_ADDITIONAL_BILLING_STATUS[ON_ADDITIONAL_BILLING_STATUS["DENIED"] = 3] = "DENIED";
    ON_ADDITIONAL_BILLING_STATUS[ON_ADDITIONAL_BILLING_STATUS["INVOICED"] = 4] = "INVOICED";
})(ON_ADDITIONAL_BILLING_STATUS = exports.ON_ADDITIONAL_BILLING_STATUS || (exports.ON_ADDITIONAL_BILLING_STATUS = {}));
exports.ON_ADDITIONAL_BILLING_STATUS_API = (_l = {},
    _l[ON_ADDITIONAL_BILLING_STATUS.PENDING] = 'pending',
    _l[ON_ADDITIONAL_BILLING_STATUS.APPROVED] = 'approved',
    _l[ON_ADDITIONAL_BILLING_STATUS.DENIED] = 'denied',
    _l[ON_ADDITIONAL_BILLING_STATUS.BILLING_ISSUE] = 'billing_issue',
    _l[ON_ADDITIONAL_BILLING_STATUS.INVOICED] = 'invoiced',
    _l);
exports.ON_ADDITIONAL_BILLING_STATUS_LIST = [
    ON_ADDITIONAL_BILLING_STATUS.PENDING,
    ON_ADDITIONAL_BILLING_STATUS.APPROVED,
    ON_ADDITIONAL_BILLING_STATUS.DENIED,
    ON_ADDITIONAL_BILLING_STATUS.BILLING_ISSUE,
    ON_ADDITIONAL_BILLING_STATUS.INVOICED,
];
exports.ON_ADDITIONAL_BILLING_STATUS_SHORT_TEXT = (_m = {},
    _m[ON_ADDITIONAL_BILLING_STATUS.PENDING] = 'Pending',
    _m[ON_ADDITIONAL_BILLING_STATUS.APPROVED] = 'Approved',
    _m[ON_ADDITIONAL_BILLING_STATUS.BILLING_ISSUE] = 'Billing Issue',
    _m[ON_ADDITIONAL_BILLING_STATUS.DENIED] = 'Denied',
    _m[ON_ADDITIONAL_BILLING_STATUS.INVOICED] = 'Invoiced',
    _m);
exports.ON_ADDITIONAL_BILLING_STATUS_FROM_API = {
    pending: ON_ADDITIONAL_BILLING_STATUS.PENDING,
    approved: ON_ADDITIONAL_BILLING_STATUS.APPROVED,
    billing_issue: ON_ADDITIONAL_BILLING_STATUS.BILLING_ISSUE,
    denied: ON_ADDITIONAL_BILLING_STATUS.DENIED,
    invoiced: ON_ADDITIONAL_BILLING_STATUS.INVOICED,
};
exports.PICKUP_LOAD_STATUSES = [
    // LOAD_STATUS.ACTIVE,
    // LOAD_STATUS.PICKUP_ACCEPTED,
    LOAD_STATUS.PICKUP_GOING,
    LOAD_STATUS.PICKUP_ARRIVED,
    // LOAD_STATUS.PICKUP_CHECKIN,
    // LOAD_STATUS.PICKUP_DEPARTED,
];
exports.DROPOFF_LOAD_STATUSES = [
    //  LOAD_STATUS.DROPOFF_ACCEPTED,
    LOAD_STATUS.DROPOFF_GOING,
    LOAD_STATUS.DROPOFF_ARRIVED,
    // LOAD_STATUS.DROPOFF_CHECKIN,
];
exports.ACTIVE_LOAD_STATUSES = [
    LOAD_STATUS.ACTIVE,
    LOAD_STATUS.PICKUP_GOING,
    LOAD_STATUS.DROPOFF_GOING,
];
exports.TRACKING_LOAD_STATUSES = [
    LOAD_STATUS.ACTIVE,
    LOAD_STATUS.PICKUP_GOING,
    LOAD_STATUS.PICKUP_ARRIVED,
    LOAD_STATUS.DROPOFF_GOING,
    LOAD_STATUS.DROPOFF_ARRIVED,
];
exports.BILLING_LOAD_STATUS = [
    LOAD_STATUS.DISPATCH_VERIFIED,
    LOAD_STATUS.BILLING_ISSUE,
    LOAD_STATUS.INVOICED,
];
exports.TRACKER_VISIBLE_STATUSES = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
    LOAD_STATUS.UNASSIGNED,
    LOAD_STATUS.PENDING_ACCEPTANCE,
    LOAD_STATUS.ASSIGNED
], __read(exports.PICKUP_LOAD_STATUSES), false), __read(exports.DROPOFF_LOAD_STATUSES), false), [
    LOAD_STATUS.DELIVERED,
    LOAD_STATUS.COMPLETED
], false), __read(exports.BILLING_LOAD_STATUS), false), [
    LOAD_STATUS.CANCELLED,
], false);
exports.ADDITIONAL_BILLING_VISIBLE_STATUS = [
    ADDITIONAL_BILLING_STATUS.PENDING,
    ADDITIONAL_BILLING_STATUS.APPROVED,
    ADDITIONAL_BILLING_STATUS.BILLING_ISSUE,
    ADDITIONAL_BILLING_STATUS.DENIED,
    ADDITIONAL_BILLING_STATUS.INVOICED,
];
exports.TRACKER_VISIBLE_AS400_STATUSES = [
    AS400_STATUS.NA,
    AS400_STATUS.PENDING,
    AS400_STATUS.ACCEPTED_A,
    AS400_STATUS.ACCEPTED_I,
    AS400_STATUS.COMPLETE,
    AS400_STATUS.DECLINED_D,
    AS400_STATUS.DECLINED_R,
    AS400_STATUS.CANCELLED,
];
var AS400_STATUS_DISPLAY_NAME;
(function (AS400_STATUS_DISPLAY_NAME) {
    AS400_STATUS_DISPLAY_NAME["NA"] = "N/A";
    AS400_STATUS_DISPLAY_NAME["NEW"] = "New";
    AS400_STATUS_DISPLAY_NAME["ACCEPTED"] = "Accepted";
    AS400_STATUS_DISPLAY_NAME["REJECTED"] = "Rejected";
    AS400_STATUS_DISPLAY_NAME["BOOKED"] = "Booked";
    AS400_STATUS_DISPLAY_NAME["CANCELLED"] = "Cancelled";
})(AS400_STATUS_DISPLAY_NAME = exports.AS400_STATUS_DISPLAY_NAME || (exports.AS400_STATUS_DISPLAY_NAME = {}));
exports.AS400_STATUS_DISPLAY = [
    AS400_STATUS_DISPLAY_NAME.NA,
    AS400_STATUS_DISPLAY_NAME.NEW,
    AS400_STATUS_DISPLAY_NAME.ACCEPTED,
    AS400_STATUS_DISPLAY_NAME.REJECTED,
    AS400_STATUS_DISPLAY_NAME.BOOKED,
    AS400_STATUS_DISPLAY_NAME.CANCELLED,
];
// These are user facing texts.
var LOAD_DISPLAY_NAME;
(function (LOAD_DISPLAY_NAME) {
    LOAD_DISPLAY_NAME["ACTIVE_LOAD"] = "Active Load";
    LOAD_DISPLAY_NAME["MY_LOADS"] = "My Loads";
    LOAD_DISPLAY_NAME["COMPLETED_LOADS"] = "Completed Orders";
    LOAD_DISPLAY_NAME["PROPOSED_LOADS"] = "Proposed Schedule";
    LOAD_DISPLAY_NAME["SCHEDULED_LOADS"] = "Schedule";
})(LOAD_DISPLAY_NAME = exports.LOAD_DISPLAY_NAME || (exports.LOAD_DISPLAY_NAME = {}));
var getBillingIssueDisplayLabel = function (description) {
    if (!description)
        return 'Billing Issue';
    switch (description) {
        case 'Not completed in AS400':
            return 'Billing Issue - AS400';
        case 'Missing Pages':
            return 'Billing Issue - Missing';
        case 'Blurry':
            return 'Billing Issue - Blurry';
        default:
            return 'Billing Issue - Other';
    }
};
exports.getBillingIssueDisplayLabel = getBillingIssueDisplayLabel;
var getDisplayStatus = function (status, description) {
    switch (status) {
        case LOAD_STATUS.UNASSIGNED:
        case LOAD_STATUS.DECLINED:
            return 'Unassigned';
        case LOAD_STATUS.PENDING_ACCEPTANCE:
            return 'Pending Acceptance';
        case LOAD_STATUS.ASSIGNED:
            return 'Accepted';
        case LOAD_STATUS.ACTIVE:
            return 'Load Started';
        case LOAD_STATUS.PICKUP_ACCEPTED:
            return 'Pickup accepted';
        case LOAD_STATUS.PICKUP_GOING:
            return 'En Route to Pickup';
        case LOAD_STATUS.PICKUP_ARRIVED:
            return 'Arrived at Pickup';
        case LOAD_STATUS.PICKUP_CHECKIN:
            return 'Checked in at Pickup';
        case LOAD_STATUS.PICKUP_DEPARTED:
            return 'Departed from Pickup';
        case LOAD_STATUS.DROPOFF_ACCEPTED:
            return 'Dropoff accepted';
        case LOAD_STATUS.DROPOFF_GOING:
            return 'En Route to Dropoff';
        case LOAD_STATUS.DROPOFF_ARRIVED:
            return 'Arrived at Dropoff';
        case LOAD_STATUS.DROPOFF_CHECKIN:
            return 'Checked in at Dropoff';
        case LOAD_STATUS.DELIVERED:
            return 'Delivered';
        case LOAD_STATUS.COMPLETED:
            return 'Dispatch Cleared';
        case LOAD_STATUS.CANCELLED:
            return 'Cancelled';
        case LOAD_STATUS.DISPATCH_VERIFIED:
            return 'Dispatch Verified';
        case LOAD_STATUS.BILLING_ISSUE:
            return (0, exports.getBillingIssueDisplayLabel)(description);
        case LOAD_STATUS.INVOICED:
            return 'Invoiced';
        default:
            return status;
    }
};
exports.getDisplayStatus = getDisplayStatus;
var getAdditionalBillingDisplayStatus = function (status) {
    switch (status) {
        case ADDITIONAL_BILLING_STATUS.APPROVED:
            return 'Approved';
        case ADDITIONAL_BILLING_STATUS.DENIED:
            return 'Denied';
        case ADDITIONAL_BILLING_STATUS.PENDING:
            return 'Pending';
        case ADDITIONAL_BILLING_STATUS.INVOICED:
            return 'Invoiced';
        case ADDITIONAL_BILLING_STATUS.BILLING_ISSUE:
            return 'Billing Issue';
        default:
            return status;
    }
};
exports.getAdditionalBillingDisplayStatus = getAdditionalBillingDisplayStatus;
var getAPIStatus = function (status) {
    switch (status) {
        case 'Unassigned':
            return LOAD_STATUS.UNASSIGNED;
        case 'Pending Acceptance':
            return LOAD_STATUS.PENDING_ACCEPTANCE;
        case 'Accepted':
            return LOAD_STATUS.ASSIGNED;
        case 'Load Started':
            return LOAD_STATUS.ACTIVE;
        case 'Pickup accepted':
            return LOAD_STATUS.PICKUP_ACCEPTED;
        case 'En Route to Pickup':
            return LOAD_STATUS.PICKUP_GOING;
        case 'Arrived at Pickup':
            return LOAD_STATUS.PICKUP_ARRIVED;
        case 'Checked in at Pickup':
            return LOAD_STATUS.PICKUP_CHECKIN;
        case 'Departed from Pickup':
            return LOAD_STATUS.PICKUP_DEPARTED;
        case 'Dropoff accepted':
            return LOAD_STATUS.DROPOFF_ACCEPTED;
        case 'En Route to Dropoff':
            return LOAD_STATUS.DROPOFF_GOING;
        case 'Arrived at Dropoff':
            return LOAD_STATUS.DROPOFF_ARRIVED;
        case 'Checked in at Dropoff':
            return LOAD_STATUS.DROPOFF_CHECKIN;
        case 'Delivered':
            return LOAD_STATUS.DELIVERED;
        case 'Completed':
            return LOAD_STATUS.COMPLETED;
        case 'Cancelled':
            return LOAD_STATUS.CANCELLED;
        default:
            return status;
    }
};
exports.getAPIStatus = getAPIStatus;
var getAS400DisplayStatus = function (status) {
    switch (status) {
        case AS400_STATUS.NA:
            return AS400_STATUS_DISPLAY_NAME.NA;
        case AS400_STATUS.PENDING:
            return AS400_STATUS_DISPLAY_NAME.NEW;
        case AS400_STATUS.ACCEPTED_A:
            return AS400_STATUS_DISPLAY_NAME.ACCEPTED;
        case AS400_STATUS.ACCEPTED_I:
            return AS400_STATUS_DISPLAY_NAME.ACCEPTED;
        case AS400_STATUS.COMPLETE:
            return AS400_STATUS_DISPLAY_NAME.BOOKED;
        case AS400_STATUS.DECLINED_D:
            return AS400_STATUS_DISPLAY_NAME.REJECTED;
        case AS400_STATUS.DECLINED_R:
            return AS400_STATUS_DISPLAY_NAME.REJECTED;
        case AS400_STATUS.CANCELLED:
            return AS400_STATUS_DISPLAY_NAME.CANCELLED;
        default:
            return status;
    }
};
exports.getAS400DisplayStatus = getAS400DisplayStatus;
// export const getAdditionalBillingChipDisplayClass = (
//   status: ADDITIONAL_BILLING_STATUS,
// ): string => {
//   switch (status) {
//     case ADDITIONAL_BILLING_STATUS.APPROVED:
//       return 'approved';
//     default:
//       return status
//   }
// };
var getChipDisplayClass = function (status) {
    switch (status) {
        case LOAD_STATUS.UNASSIGNED:
        case LOAD_STATUS.DECLINED:
        case LOAD_STATUS.BILLING_ISSUE:
            return 'unassigned';
        case LOAD_STATUS.PENDING_ACCEPTANCE:
        case LOAD_STATUS.ASSIGNED:
        case LOAD_STATUS.ACTIVE:
        case LOAD_STATUS.PICKUP_ACCEPTED:
        case LOAD_STATUS.PICKUP_GOING:
        case LOAD_STATUS.PICKUP_ARRIVED:
        case LOAD_STATUS.PICKUP_CHECKIN:
        case LOAD_STATUS.COMPLETED:
            return 'pickup';
        case LOAD_STATUS.PICKUP_DEPARTED:
        case LOAD_STATUS.DROPOFF_ACCEPTED:
        case LOAD_STATUS.DROPOFF_GOING:
        case LOAD_STATUS.DROPOFF_ARRIVED:
        case LOAD_STATUS.DROPOFF_CHECKIN:
            return 'dropoff';
        case LOAD_STATUS.DELIVERED:
        case LOAD_STATUS.INVOICED:
            return 'delivered';
        case LOAD_STATUS.DISPATCH_VERIFIED:
            return 'completed';
        case LOAD_STATUS.CANCELLED:
            return 'cancelled';
        default:
            return status;
    }
};
exports.getChipDisplayClass = getChipDisplayClass;
exports.NEXT_SWIPE_LOAD_STATUS = (_o = {},
    _o[LOAD_STATUS.UNASSIGNED] = LOAD_STATUS.PENDING_ACCEPTANCE,
    _o[LOAD_STATUS.DECLINED] = LOAD_STATUS.PENDING_ACCEPTANCE,
    _o[LOAD_STATUS.PENDING_ACCEPTANCE] = LOAD_STATUS.ASSIGNED,
    _o[LOAD_STATUS.ASSIGNED] = LOAD_STATUS.ACTIVE,
    _o[LOAD_STATUS.ACTIVE] = LOAD_STATUS.PICKUP_GOING,
    _o[LOAD_STATUS.PICKUP_ACCEPTED] = LOAD_STATUS.PICKUP_GOING,
    _o[LOAD_STATUS.PICKUP_GOING] = LOAD_STATUS.PICKUP_CHECKIN,
    _o[LOAD_STATUS.PICKUP_ARRIVED] = LOAD_STATUS.PICKUP_CHECKIN,
    _o[LOAD_STATUS.PICKUP_CHECKIN] = LOAD_STATUS.PICKUP_DEPARTED,
    _o[LOAD_STATUS.PICKUP_DEPARTED] = LOAD_STATUS.DROPOFF_CHECKIN,
    _o[LOAD_STATUS.DROPOFF_ACCEPTED] = LOAD_STATUS.DROPOFF_CHECKIN,
    _o[LOAD_STATUS.DROPOFF_GOING] = LOAD_STATUS.DROPOFF_CHECKIN,
    _o[LOAD_STATUS.DROPOFF_ARRIVED] = LOAD_STATUS.DROPOFF_CHECKIN,
    _o[LOAD_STATUS.DROPOFF_CHECKIN] = LOAD_STATUS.DELIVERED,
    _o[LOAD_STATUS.DELIVERED] = null,
    _o[LOAD_STATUS.COMPLETED] = null,
    _o[LOAD_STATUS.CANCELLED] = null,
    _o[LOAD_STATUS.DISPATCH_VERIFIED] = null,
    _o[LOAD_STATUS.INVOICED] = null,
    _o[LOAD_STATUS.BILLING_ISSUE] = null,
    _o);
var getNextStatus = function (status) {
    return exports.NEXT_SWIPE_LOAD_STATUS[status] || null;
};
exports.getNextStatus = getNextStatus;
var getTransitions = function (status) {
    switch (status) {
        // case LOAD_STATUS.UNASSIGNED:
        // case LOAD_STATUS.DECLINED:
        //   return [[LOAD_TRANSITION.ASSIGN_DRIVER]];
        // case LOAD_STATUS.PENDING_ACCEPTANCE:
        //   return [[LOAD_TRANSITION.ACCEPT], [LOAD_TRANSITION.DECLINE]];
        case LOAD_STATUS.ASSIGNED:
            return [{ fn: LOAD_TRANSITION.PICKUP_GO }];
        case LOAD_STATUS.PICKUP_ACCEPTED:
            return [{ fn: LOAD_TRANSITION.PICKUP_GO }];
        case LOAD_STATUS.ACTIVE:
            return [{ fn: LOAD_TRANSITION.PICKUP_GO }];
        case LOAD_STATUS.PICKUP_GOING:
            return [{ fn: LOAD_TRANSITION.BULK_PICKUP_ARRIVE }];
        case LOAD_STATUS.PICKUP_ARRIVED:
            return [{ fn: LOAD_TRANSITION.PICKUP_CHECKIN }];
        case LOAD_STATUS.PICKUP_CHECKIN:
            return [{ fn: LOAD_TRANSITION.BULK_PICKUP_DEPART }];
        case LOAD_STATUS.PICKUP_DEPARTED:
            return [{ fn: LOAD_TRANSITION.BULK_DROPOFF_FULL }];
        case LOAD_STATUS.DROPOFF_GOING:
            return [{ fn: LOAD_TRANSITION.BULK_DROPOFF_ARRIVE }];
        case LOAD_STATUS.DROPOFF_ARRIVED:
            return [{ fn: LOAD_TRANSITION.DROPOFF_CHECKIN }];
        case LOAD_STATUS.DROPOFF_CHECKIN:
            return [{ fn: LOAD_TRANSITION.DROPOFF_COMPLETE }];
        case LOAD_STATUS.DELIVERED:
            return [];
        default:
            return [];
    }
};
exports.getTransitions = getTransitions;
exports.LOAD_ORDER = [
    LOAD_STATUS.UNASSIGNED,
    LOAD_STATUS.PENDING_ACCEPTANCE,
    LOAD_STATUS.ASSIGNED,
    LOAD_STATUS.PICKUP_GOING,
    LOAD_STATUS.PICKUP_ARRIVED,
    LOAD_STATUS.DROPOFF_GOING,
    LOAD_STATUS.DROPOFF_ARRIVED,
    LOAD_STATUS.DELIVERED,
    LOAD_STATUS.COMPLETED,
];
exports.INACTIVE_STATUSES = [
    LOAD_STATUS.UNASSIGNED,
    LOAD_STATUS.PENDING_ACCEPTANCE,
    LOAD_STATUS.ASSIGNED,
];
exports.TIMESTAMPD_STATUSES = [
    LOAD_STATUS.PICKUP_GOING,
    LOAD_STATUS.PICKUP_ARRIVED,
    LOAD_STATUS.DROPOFF_GOING,
    LOAD_STATUS.DROPOFF_ARRIVED,
    LOAD_STATUS.DELIVERED,
];
exports.BILLING_STATUSES = [
    LOAD_STATUS.DISPATCH_VERIFIED,
    LOAD_STATUS.BILLING_ISSUE,
    LOAD_STATUS.INVOICED,
];
exports.ALLOWED_OPERATIONAL_BILLING_STATUSES = [
    LOAD_STATUS.DELIVERED,
    LOAD_STATUS.COMPLETED,
];
exports.TABLE_ROW_FETCH_LIMIT = 25;
exports.VISIBLE_ID_FETCH_LIMIT = 25;
